import { environment } from "../../../../environments/environment";

/** Costanti generiche */
export const appRsMapConstants = {
  /** Colori */
  colors: {
    command: {
      search: "dodgerblue",
    },
    marker: {
      destination: "#8DC73B",
      default: "#7B9DAF",
      order: "#FFA500"  // orange
    },
    tripRoute: '#669DF6'
  },
  /** Url per utilizzo api Google */
  googleApiUrl: "https://maps.googleapis.com/maps/api/js?key=",
  /** Chiavi su localstorage */
  localStorageKeys: {
    isUsingDual: "rsmap:isUsingDual",
    mapUserSettings: "rsmap:userSettings",
    onePageAuthGuardKey: "rsmap:onePageAuthGuardKey"
  },
  opacity: {
    full: 1,
    light: 0.6
  },
  panelGridPrefix: 'grid-',
  productFieldPrefix: "$$", // Prefisso field colonna prodotto in dettaglio consegne/ordini
  /** Definizione delle rotte Angular */
  routesUri: {
    dummy: '/_dummy',
    rsmap: '/rsmap/map',
    rsmapDual: {
      leaflet: '/rsmap/map-dual-leaflet',
      panels: '/rsmap/map-dual-panels'
    }
  }
};

export const appRsMapMetadataConstants = {
  routingParameters: environment.appSettings.apiNamespaceBase + 'Planning.EntitiesDTO.RoutingParametersDTO'
};
